<template>
  <div v-if="isAzal" :class="['provider-links', { 'provider-links--mobile': mobile }]">
    <a href="https://www.aeroclass.org/app/courses/" target="_blank" class="provider-link">
      <img alt="Aeroclass" src="/media/images/providers/aeroclass.jpg"/>
      <span v-if="mobile" class="provider-link-text">Aeroclass</span>
    </a>

    <a href="https://www.linkedin.com/learning/" target="_blank" class="provider-link">
      <img alt="LinkedIn Learning" src="/media/images/providers/linkedin-learning.png"/>
      <span v-if="mobile" class="provider-link-text">LinkedIn Learning</span>
    </a>

    <a href="https://azal.udemy.com/" target="_blank" class="provider-link">
      <img alt="Udemy Business" src="/media/images/providers/udemy-business.png"/>
      <span v-if="mobile" class="provider-link-text">Udemy Business</span>
    </a>
  </div>
</template>

<script>
export default {
  name: "ProviderLinks",
  props: {
    isAzal: {
      type: Boolean,
      default: false,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
/* Desktop Layout */
.provider-links {
  display: flex;
  align-items: center;
  padding-left: 16px;
  border-left: 1px solid rgba(255, 255, 255, 0.15);
  gap: 4px;
}

.provider-links .provider-link {
  display: inline-flex;
  align-items: center;
  transition: opacity 0.2s ease;
  opacity: 0.85;
}

.provider-links .provider-link:hover {
  opacity: 1;
}

.provider-links .provider-link img {
  width: 110px;
  height: 28px;
  object-fit: contain;
  border-radius: 4px;
}

/* Mobile Layout (SideNav) */
.provider-links--mobile {
  display: flex;
  flex-direction: column;
  margin-left: 0;
  border-top: 1px solid #e9ecef;
  padding: 8px 0;
}

.provider-links--mobile .provider-link {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 20px;
  color: #495057;
  text-decoration: none;
  transition: all 0.2s ease;
}

.provider-links--mobile .provider-link:hover {
  background-color: #f8f9fa;
}

.provider-links--mobile .provider-link img {
  width: 60px;
  height: 20px;
  object-fit: contain;
  flex-shrink: 0;
}

.provider-links--mobile .provider-link-text {
  flex: 1;
  margin-left: 12px;
  font-size: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
